import React, { useState } from 'react';
import { getAuth, signInWithEmailAndPassword, createUserWithEmailAndPassword } from "firebase/auth";
import { getDatabase, ref, set, get } from "firebase/database";

function Login(props) {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [verifyPassword, setVerifyPassword] = useState('');
    const [username, setUsername] = useState('');
    const [errorMessage, setErrorMessage] = useState(null);
    const [isLogin, setIsLogin] = useState(false); // for toggling between login and signup

    const auth = getAuth();


    const doesUsernameExist = async (username) => {
        const db = getDatabase();
        const usernameRef = ref(db, `usernames/${username}`);
        const snapshot = await get(usernameRef);
        return snapshot.exists();
    };

    const validatePassword = () => {
        if (password !== verifyPassword) {
            setErrorMessage("Passwords do not match!");
            setTimeout(() => {
                setErrorMessage(null);  // Clear the error message after 3 seconds
            }, 3000); 
            return false;
        }
        if (password.length < 8) {
            setErrorMessage("Password must be at least 8 characters long!");
            setTimeout(() => {
                setErrorMessage(null);  // Clear the error message after 3 seconds
            }, 3000); 
            return false;
        }
        if (!/[a-zA-Z]/.test(password) || !/[0-9]/.test(password)) {
            setErrorMessage("Password must contain at least one letter and one number!");
            setTimeout(() => {
                setErrorMessage(null);  // Clear the error message after 3 seconds
            }, 3000); 
            return false;
        }
        return true;
    }

    const handleSignUp = async () => {
        if (!validatePassword()) {
            return;
        }
    
        // Check for username existence
        if (await doesUsernameExist(username)) {
            setErrorMessage('Username already taken. Please choose another.');
            setTimeout(() => {
                setErrorMessage(null);  // Clear the error message after 3 seconds
            }, 3000); 
            return;
        }
    
        try {
            const userCredential = await createUserWithEmailAndPassword(auth, email, password);
            const user = userCredential.user;
    
            // Save user data in Realtime Database
            const db = getDatabase();
            await set(ref(db, `users/${user.uid}`), {
                email: user.email,
                uid: user.uid,
                username: username, // Add this line
                blockedConversations:{}
                // ... any other data you want to save for the user
            });
    
            // After successful registration, also store the username in the `usernames` node
            await set(ref(db, `usernames/${username}`), user.uid);
    
            props.onAuthenticated();  // Call the passed callback
            props.setShowFarmposts(false);
            props.setShowUserProfile(true);
            
        } catch (error) {
            setErrorMessage(error.message);
            setTimeout(() => {
                setErrorMessage(null);  // Clear the error message after 3 seconds
            }, 3000); 
        }
    };
    

    const handleLogin = async () => {
        try {
            await signInWithEmailAndPassword(auth, email, password);
            props.onAuthenticated();  // Call the passed callback
        } catch (error) {
            setErrorMessage(error.message);
            setTimeout(() => {
                setErrorMessage(null);  // Clear the error message after 3 seconds
            }, 3000); 
        }
    }

    return (
        <div>
            <div className="login_form_header_container"><div className="login_form_header">{isLogin ? "Welcome Back!" : "Join the Community"}</div></div>
           <div className="login_form_body">
            
            
           {!isLogin && (
                <div>
                    <label className="login_form_password_2_label">Pick a Username</label>
                    <input className="login_form_email_input" maxLength={20} value={username} onChange={(e) => setUsername(e.target.value)} />
                </div>
            )}
            <div>
                <label className="login_form_email_label">Email </label>
                <input className="login_form_email_input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
            </div>
            <div>
                <label className="login_form_password_label">Password </label>
                <input className="login_form_password_input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
            </div>
            {!isLogin && (
                <div>
                    <label className="login_form_password_2_label">Verify Password </label>
                    <input className="login_form_password_input" type="password" value={verifyPassword} onChange={(e) => setVerifyPassword(e.target.value)} />
                </div>
            )}
            
            
            </div>
<div className="login_form_error_box">
{errorMessage && <div className="create_post_error_message_container"><div className="create_post_error_message">{errorMessage}</div></div>}</div>

            <div className="login_form_login_signup_button_container">
                {isLogin ? (
                    <button className="login_form_login_signup_button" onClick={handleLogin}>Sign In</button>
                ) : (
                    <button className="login_form_login_signup_button" onClick={handleSignUp}>Create Account</button>
                )}
            </div>
            
            <div className="login_form_alternate_signup_container">
                {isLogin ? (
                    <button className="login_form_alternate_login_signup" onClick={() => setIsLogin(false)}>Don't have an account? Sign Up!</button>
                ) : (
                    <button className="login_form_alternate_login_signup" onClick={() => setIsLogin(true)}>Already have an account? Log In!</button>
                )}
            </div>
        </div>
    );
}

export default Login;
